import apiClient from '@/lib/apiClient';
import type { Employee } from './types';

export async function fetchEmployeeInfo(login: string): Promise<Employee> {
  const { data } = await apiClient.get<Employee>(`/api/employees/${login}`);
  return data;
}
